import { useStore } from 'components/Store';
import featureFlagRenderItem from 'helpers/featureFlagRenderItem';
import { useFlags } from 'launchdarkly-react-client-sdk';

const useTasksFlags = () => {
  const {
    releaseFeLegacyTaskDecommission,
    releaseFeLegacyTaskDecommissionByOrg
  } = useFlags();

  const { state } = useStore();
  const { id } = state?.organization || {};

  return {
    isTasksDisabled: featureFlagRenderItem(
      releaseFeLegacyTaskDecommission,
      releaseFeLegacyTaskDecommissionByOrg,
      id
    )
  };
};

export default useTasksFlags;
